import { render, staticRenderFns } from "./OfficeOrders.vue?vue&type=template&id=0c3aa763&scoped=true&"
import script from "./OfficeOrders.vue?vue&type=script&lang=js&"
export * from "./OfficeOrders.vue?vue&type=script&lang=js&"
import style0 from "./OfficeOrders.vue?vue&type=style&index=0&id=0c3aa763&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3aa763",
  null
  
)

export default component.exports